module.exports = __webpack_public_path__ + "static/img/bg_de.ec89d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xmasSaled-2025/bg_de.png
// module id = Ue09
// module chunks = 1